define([
    "./commentModule",
    "./commentService",
    "./commentDetails",
    "./newComment",
    "./nlgComments"
], function () {
});